import { ApplicationRoutes } from '../../../app-routes-names'

export const CustomersRoutes = {
  report: 'report',
  list: 'list',
  communicationType: 'communication-type',
  detail: 'detail/:customerId',
  detailWithInvoice: 'detail/:customerId/invoice/:invoiceId',
  detailWithCall: 'detail/:customerId/call/:callId'
}

const { contacts } = ApplicationRoutes

export const CustomersPaths = {
  report: `/${contacts}/${CustomersRoutes.report}`,
  list: `/${contacts}/${CustomersRoutes.list}`,
  communicationType: `/${contacts}/${CustomersRoutes.communicationType}`,
  detail: (customerId: string) =>
    `/${contacts}/${CustomersRoutes.detail.replace(':customerId', customerId)}`,
  detailWithInvoice: (customerId: string, invoiceId: string) =>
    `/${contacts}/${CustomersRoutes.detailWithInvoice
      .replace(':customerId', customerId)
      .replace(':invoiceId', invoiceId)}`,
  detailWithCall: (customerId: string, callId: string) =>
    `/${contacts}/${CustomersRoutes.detailWithCall
      .replace(':customerId', customerId)
      .replace(':callId', callId)}`
}
